export default __webpack_public_path__ + "static/media/git.d0d6beab.svg";